export class InvalidUrlError extends Error {}
